import { AUTH_TOKEN } from '../configs/AppConfig';
import { MENU_ITEMS, PERMISSION_METRICS, USER } from '../redux/constants/Auth';

export const RemoveAuthItems = () => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(PERMISSION_METRICS);
  localStorage.removeItem(USER);
  localStorage.removeItem(MENU_ITEMS);
};
